export default __webpack_public_path__ + "b816cda3107bb21c87e131350878a58b.woff2";